import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sambhajinagar-chess-tournament',
  templateUrl: './sambhajinagar-chess-tournament.component.html',
  styleUrls: ['./sambhajinagar-chess-tournament.component.scss']
})
export class SambhajinagarChessTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
